<script>
import _ from 'lodash'
import {
  notificationComputed,
  notificationMethods,
} from '@state/helpers/notification'
import { agentDetailsComputed } from '@state/helpers/agent-details'
import agentDetailItems from './agentDetailItems'

export default {
  props: {
    disabled: {
      type: Boolean,
    },
    fields: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [],
      optionsStatus: [],
    }
  },
  computed: {
    ...notificationComputed,
    ...agentDetailsComputed,
    fieldsComputed() {
      return { ...this.fields }
    },
    itemsComputed() {
      return [...agentDetailItems, ...this.items]
    },
    showStatus() {
      return this.optionsStatus.length !== 0
    },
  },
  watch: {
    getDetails() {
      const response = this.getDetails
      if (response) {
        const optionsStatus = []
        for (let index = 1; index <= 8; index++) {
          optionsStatus.push({
            label: response[`status${index}_name`],
            value: `${index}`,
          })
        }
        this.optionsStatus = optionsStatus

        const items = []
        const questions = this.agentDetailFilterByKey(/\bquestion[0-9]\b/)
        _.forEach(questions, (value, key) => {
          if (value) {
            const questionNumber = _.chain(key)
              .split('')
              .last()
              .value()
            const answerKey = `answer${questionNumber}`
            const answer = this.getDetails[answerKey]
            items.push({
              key: answerKey,
              label: value,
              as: answer ? 'checkboxGroup' : 'input',
              ...(!answer && {
                placeholder: 'キーワードをスペースで区切り入力してください',
              }),
              ...(answer && {
                options: answer.split(',')?.map(function(item) {
                  return { label: item, value: item }
                }),
              }),
              ...(!answer && {
                rules: {
                  required: false,
                  max: 1000,
                },
              }),
            })
          }
        })
        this.items = items
      }
    },
  },
  methods: {
    ...notificationMethods,
    agentDetailFilterByKey(regexr) {
      return _.pickBy(this.getDetails, (value, key) => {
        if (new RegExp(regexr).test(key)) return key
      })
    },
    handleChangeData(field, value) {
      this.$emit('update:agent', field, value)
    },
    handleChangeInputData(field, value) {
      this.$emit('update:agentInput', field, value)
    },
  },
}
</script>

<template>
  <div v-if="showStatus">
    <CRow v-for="item in itemsComputed" :key="item.key">
      <CCol v-if="item.key !== 'member_status' || showStatus" sm="3">{{
        item.label
      }}</CCol>
      <CCol sm="9">
        <div
          v-if="item.key === 'member_status' && showStatus"
          class="d-flex justify-content-around form-group"
        >
          <BaseCheckboxGroup
            :class-checkbox="'checkbox-group-w-50'"
            :vee-name="item.name"
            custom
            inline
            :disabled="disabled"
            :readonly="disabled"
            :checked="(fields[item.name] || '').split(',')"
            :options="optionsStatus"
            :rules="item.rules"
            @update:checked="(v) => handleChangeData(item.name, v)"
          />
        </div>
        <BaseInput
          v-if="item.as === 'input'"
          :placeholder="item.placeholder"
          :vee-name="item.name"
          :plaintext="disabled"
          :value="fieldsComputed[item.key]"
          :rules="item.rules"
          @update:value="(v) => handleChangeInputData(item.key, v)"
        />
        <div class="form-group">
          <BaseCheckboxGroup
            v-if="item.as === 'checkboxGroup' && item.key !== 'member_status'"
            custom
            class="flex-grow-1"
            :options="item.options"
            :disabled="disabled"
            :checked="(fieldsComputed[item.key] || '').split(',')"
            @update:checked="(v) => handleChangeData(item.key, v)"
          />
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<style lang="scss">
.checkbox-group-w-50 {
  .custom-control {
    justify-content: start;
    width: calc(50% - 1.5rem);
  }
}
</style>
